(() => {
  const VIP_HEART_ICON = `
    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-accordion icon-heart" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
      <path fill-rule="evenodd" d="M10 5.24 8.515 3.773a4.433 4.433 0 0 0-6.21 0 4.293 4.293 0 0 0 0 6.128L10 17.495l7.695-7.593a4.293 4.293 0 0 0 0-6.128 4.433 4.433 0 0 0-6.21 0zm.765-2.177c2.113-2.084 5.538-2.084 7.65 0a5.29 5.29 0 0 1 0 7.55l-7.695 7.593a1.03 1.03 0 0 1-1.44 0l-7.696-7.594a5.29 5.29 0 0 1 0-7.549C3.697.98 7.122.98 9.234 3.063l.766.755z"/>
    </svg>
  `;

  const updateVipIcon = (root = document) => {
    root.querySelectorAll('.icon-with-text__item .inline-richtext').forEach((heading) => {
      if (!heading.textContent.trim().toLowerCase().startsWith('join vip')) return;

      const iconWrapper = heading.closest('.icon-with-text__item')?.querySelector('.svg-wrapper');
      if (!iconWrapper || iconWrapper.dataset.customVipIcon === 'true') return;

      iconWrapper.innerHTML = VIP_HEART_ICON;
      iconWrapper.dataset.customVipIcon = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateVipIcon(), { once: true });
  } else {
    updateVipIcon();
  }

  document.addEventListener('shopify:section:load', (event) => updateVipIcon(event.target));
})();
